import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-architektur',
  templateUrl: './architektur.component.html',
  styleUrls: ['./architektur.component.scss']
})
export class ArchitekturComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
